// intercomJwtCache.ts
import { Preferences } from '@capacitor/preferences';

const KEY = 'intercom_jwt_v1';

// small buffer so you refresh a bit before it expires
const EXP_SKEW_SECONDS = 60;

export async function loadIntercomJwt(): Promise<string | null> {
  const { value } = await Preferences.get({ key: KEY });
  return value ?? null;
}

export async function saveIntercomJwt(token: string): Promise<void> {
  await Preferences.set({ key: KEY, value: token });
}

export async function clearIntercomJwt(): Promise<void> {
  await Preferences.remove({ key: KEY });
}

// Decodes exp from the JWT payload (no signature verification; just cache hygiene)
export function isJwtUsable(
  token: string,
  nowSeconds = Math.floor(Date.now() / 1000),
  skewSeconds = EXP_SKEW_SECONDS,
) {
  try {
    const [, payloadB64] = token.split('.');
    if (!payloadB64) return false;

    // base64url -> base64
    const b64 = payloadB64.replace(/-/g, '+').replace(/_/g, '/');
    const json = JSON.parse(atob(b64));
    const exp = typeof json.exp === 'number' ? json.exp : null;
    if (!exp) return false;

    return exp > nowSeconds + skewSeconds;
  } catch {
    return false;
  }
}
